import * as esbuild from "esbuild-wasm";
// import { optimize } from "svgo";
// import localForage from "localforage";
import { path } from "@sandbox/utils";
import svg64 from "svg64";

// const fileCache = localForage.createInstance({
//   name: "fileCache",
// });

export interface FileSet {
  [filePath: string]: string;
}

const extensions = [".js", ".jsx", ".ts", ".tsx", ".json"];

export const filesPlugin = (
  sources: FileSet,
  external: string[]
): esbuild.Plugin => {
  return {
    name: "sandbox-files-loader",
    setup(build: esbuild.PluginBuild) {

      build.onResolve({ filter: /.*/ }, async (args) => {
        if (external.includes(args.path))
          return {
            external: true,
            path: args.path
          }

        const filePath = path.resolve(args.resolveDir, args.path);
        if (sources[filePath] !== undefined) {
          return {
            path: filePath,
          }
        } else {
          const extension = path.extname(filePath);
          if (!extension) {
            const matchingExt = extensions.find((ext) => sources[`${filePath}${ext}`])
            if (matchingExt)
              return {
                path: `${filePath}${matchingExt}`,

              }
            else
              return {
                errors: [{ text: `Failed to resolve file path: ${filePath}` }]
              }
          } else {
            return {
              errors: [{ text: `Failed to resolve file path: ${filePath}` }]
            }
          }
        }
      });

      build.onLoad({ filter: /.*\.(ts|tsx|js|jsx|txt|json)$/ }, async (args: esbuild.OnLoadArgs) => {
        const contents = sources[args.path];
        if (contents === undefined)
          return {
            errors: [{
              text: `File does not exists: ${args.path}`
            }]
          }

        let loader: esbuild.Loader = "js";

        if (/.*\.(ts|tsx|jsx)$/.test(args.path)) loader = "tsx";
        if (args.path.endsWith(".json")) loader = "json";
        if (args.path.endsWith(".txt")) loader = "text";

        const result: esbuild.OnLoadResult = {
          loader,
          contents,
        }

        return result;
      });

      // load images from /public folder as url, images imported from source folders as base64
      build.onLoad({ filter: /\.(jpg|jpeg|png|apng|gif|webp|bmp|avif)$/ }, async args => {
        let contents = sources[args.path];
        if (contents === undefined)
          return {
            errors: [{
              text: `File does not exists: ${args.path}`
            }]
          }

        return {
          loader: "text",
          contents: args.path.startsWith("/public") ? args.path.slice(7) : contents
        };
      });

      // load svg's as base64
      build.onLoad({ filter: /\.svg$/ }, async args => {
        let contents = sources[args.path];
        if (contents === undefined)
          return {
            errors: [{
              text: `File does not exists: ${args.path}`
            }]
          }

        contents = svg64(contents)
        // contents = optimize(contents, {
        //   path: args.path,
        //   datauri: "base64"
        // }).data;

        return {
          loader: "text",
          contents
        };
      });
    },
  };
};